module.exports = __webpack_public_path__ + "static/media/rollet_gor_slid.e3dc832c.png";